export default {"src":"/_next/static/media/speakers.332185b6.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};